const rawVersion =
  process.env.NEXT_PUBLIC_APP_VERSION ||
  process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
  '1.0.1'

export const APP_VERSION = rawVersion ? rawVersion : null
console.log('App Version:', APP_VERSION)
